import * as $protobuf from 'protobufjs/light';
import { Enum } from 'protobufjs/light';
import { validate, validated } from './Symbols';

// Decode int64/uint64 fields as plain JS numbers instead of Long objects.
// Browser bundles always decoded numbers (webpack never bundled `long`) until
// protobufjs 7.6 started requiring it statically, which broke every consumer
// that expects numbers (e.g. Dinero's Number.isInteger check on Money.amount).
// Every generated model imports this module, so this runs before any decode.
//
// WARNING: 64-bit values beyond Number.MAX_SAFE_INTEGER (2^53 - 1) silently
// lose precision when decoded as numbers. All current fields are safe — money
// in cents, μs timestamps (~1.8e15, safe until the year 287396), and DB ids —
// but don't add fields that can exceed 2^53. The wrapper below warns if one
// ever does.
$protobuf.util.Long = null;
$protobuf.configure();

['int64', 'uint64', 'sint64', 'fixed64', 'sfixed64'].forEach((method) => {
  const original = $protobuf.Reader.prototype[method];
  $protobuf.Reader.prototype[method] = function checkSafeInteger() {
    const value = original.call(this);
    if (!Number.isSafeInteger(value)) {
      // eslint-disable-next-line no-console
      console.warn(
          `protobuf ${method} value ${value} exceeds Number.MAX_SAFE_INTEGER and lost precision`
      );
    }
    return value;
  };
});

function addInstanceof(Type) {
  // This lets `message instanceof Type` work
  Type[Symbol.hasInstance] = (instance) => instance instanceof Type.ctor;
}

function getChildren(field, value) {
  if (field.repeated) {
    return value;
  } else if (field.map) {
    return [...Object.values(value)];
  } else {
    return [value];
  }
}

// Fixes create to make sure the Message has the correct types.
// It accepts the interfaces for the objects (regular objects potentially missing fields),
// but we then expect it to have the correct child Message objects.
function fixCreate(Type) {
  const originalCreate = Type.create.bind(Type);

  Type.create = (...args) => {
    const created = originalCreate(...args);

    for (const field of Object.values(Type.fields)) {
      // This is not the type of field we need to convert
      if (!created[field.name] || !field.resolvedType || field.resolvedType instanceof Enum) {
        continue;
      }

      if (field.repeated) {
        created[field.name] = created[field.name].map((value) => {
          if (value instanceof field.resolvedType) {
            return value;
          } else {
            return field.resolvedType.create(value);
          }
        });
      } else if (field.map) {
        created[field.name] = Object.fromEntries(
            Object.entries(created[field.name]).map(([key, value]) => {
              if (value instanceof field.resolvedType) {
                return [key, value];
              } else {
                return [key, field.resolvedType.create(value)];
              }
            })
        );
      } else {
        // This is already an instance of the type, so no need to convert it.
        if (!(created[field.name] instanceof field.resolvedType)) {
          // We have a plain object (or the wrong type) but we want a Message.
          created[field.name] = field.resolvedType.create(created[field.name]);
        }
      }
    }

    return created;
  };
}

function addValidations(Type, validationOptions = {}) {
  const existingDescriptor = Object.getOwnPropertyDescriptor(Type.__proto__, 'ctor');

  // This way the validation methods get added to any ctor added to this type, including
  // the default one that needs to be lazily created later.
  Object.defineProperty(Type, 'ctor', {
    ...existingDescriptor,
    get: function() {
      return existingDescriptor.get.call(Type);
    },
    set: function(ctor) {
      existingDescriptor.set.call(Type, ctor);

      ctor.prototype[validate] = function () {
        for (const [propertyName, options] of Object.entries(validationOptions)) {
          for (const [validationType, validationValue] of Object.entries(options)) {
            switch (validationType) {
              case 'required':
                if (!Object.prototype.hasOwnProperty.call(this, propertyName)) {
                  throw new TypeError(`Invalid ${propertyName}`);
                }
                break;
              case 'notEmpty':
                const value = this[propertyName];
                const field = Type.fields[propertyName];
                if (!getChildren(field, value).every((v) => v && v.length > 0)) {
                  throw new TypeError(`Invalid ${propertyName}`);
                }
                break;
            }
          }

          for (const [propertyName, field] of Object.entries(Type.fields)) {
            const value = this[propertyName];
            for (const childValue of getChildren(field, value)) {
              childValue?.[validate]?.();
            }
          }
        }
      }

      ctor.prototype[validated] = function () {
        this[validate]();
        return this;
      }

      if (!ctor.prototype.validate) {
        ctor.prototype.validate = ctor.prototype[validate];
      }

      if (!ctor.prototype.validated) {
        ctor.prototype.validated = ctor.prototype[validated];
      }
    }
  })

  Type.validateAndCreate = (...args) => {
    return Type.create(...args)[validated]();
  }
}

export function fixType(Type, validationOptions) {
  addInstanceof(Type);
  fixCreate(Type);
  addValidations(Type, validationOptions);
}
